var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      attrs: { "element-loading-text": "查询中..." }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.dealInqryVoucher.title))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.dealInqryVoucher.expireDate))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("内容摘要")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", [
              _c("span", [_vm._v(_vm._s(_vm.dealInqryVoucher.digest))]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "swb-btn-link",
                  class: { "display-none": !_vm.isShow },
                  on: { click: _vm.checkContent }
                },
                [_vm._v("查看")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: { "display-none": _vm.isShow } },
              [
                _c("swb-ck-editor", {
                  ref: "theCkEditor",
                  attrs: {
                    content: _vm.content,
                    imageXtHandler: _vm.imageXtHandler
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "i",
              {
                staticClass: "swb-btn-link",
                class: { "display-none": _vm.isShow },
                on: {
                  click: function($event) {
                    _vm.hiddleCount()
                  }
                }
              },
              [_vm._v("隐藏内容")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.dealInqryVoucher.contactName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.dealInqryVoucher.contactTel))])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showFlag
        ? _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _vm.dealInqryVoucher.tradeType == _vm.tradeTypeGoodsEnum.value
                  ? _c("span", [_vm._v(_vm._s(_vm.tradeTypeGoodsEnum.text))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dealInqryVoucher.tradeType == _vm.tradeTypeServcEnum.value
                  ? _c("span", [_vm._v(_vm._s(_vm.tradeTypeServcEnum.text))])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [_vm._v("询盘方式")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _vm.dealInqryVoucher.directed
                  ? _c("span", [_vm._v("定向询盘")])
                  : _c("span", [_vm._v("公开询盘")])
              ])
            ]),
            _vm._v(" "),
            _vm.dealInqryVoucher.directed
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("询盘商户")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c(
                      "ul",
                      { staticClass: "clearfix" },
                      _vm._l(_vm.dealInqryVoucher.dealInqryMerchtList, function(
                        dealInqryMercht
                      ) {
                        return _c("li", { staticClass: "mr20 fl" }, [
                          _vm._v(_vm._s(dealInqryMercht.merchantName))
                        ])
                      })
                    )
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.dealInqryVoucher.deliverAddr))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.dealInqryVoucher.applyDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.dealInqryVoucher.auditDesc))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("报盘详情")]),
        _vm._v(" "),
        _vm.dealInqryVoucher.directed
          ? _c("span", { staticClass: "fr font12" }, [
              _vm._v(
                "本次询盘共定向询盘" +
                  _vm._s(_vm.merchantCount) +
                  "家商户，总共有" +
                  _vm._s(_vm.dealInqryVoucher.dealReplyVoucherCount) +
                  "报盘"
              )
            ])
          : _c("span", { staticClass: "fr font12" }, [
              _vm._v(
                "本次询盘公开询盘，总共有" +
                  _vm._s(_vm.dealInqryVoucher.dealReplyVoucherCount) +
                  "报盘"
              )
            ])
      ]),
      _vm._v(" "),
      _vm.dealInqryVoucher.dealReplyVoucherCount > 0
        ? _c(
            "div",
            [
              _c("swb-deal-reply-voucher-list", {
                attrs: { inqryVoucherId: _vm.id }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("询盘信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("询盘名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("截止日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("询盘类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("询盘地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核描述")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69925064", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69925064","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/InqryVoucher/DealInqryVoucherInfo.vue
// module id = 3270
// module chunks = 0